const { GET_EXP_FEED, ADD_ONE_EXP_HOME, REMOVE_ONE_EXP_HOME, HOMEPAGE_ERROR,
UPDATE_EXP_FEED, RESET_EXP_FEED, UPDATE_ONE_EXP_HOME,
OPEN_NEW_EXP } = require("../types");

export const getExpFeed = (responseData) => async dispatch => {
  dispatch({
    type: GET_EXP_FEED, 
    payload: responseData
  })
}

export const updateExpFeed = (responseData) => async dispatch => {
  dispatch({
    type: UPDATE_EXP_FEED,
    payload: responseData
  })
}

export const addOneExpHome = (exp) => dispatch => {
  dispatch({
    type: ADD_ONE_EXP_HOME, 
    payload: exp 
  })
}

export const resetExpFeed = () => dispatch => {
  dispatch({
    type: RESET_EXP_FEED
  })
}


export const removeOneExpHome = (expId) => dispatch => {
  dispatch({
    type: REMOVE_ONE_EXP_HOME,
    payload: expId 
  })
}

export const updateOneExpHome = (exp) => dispatch => {
  dispatch({
    type: UPDATE_ONE_EXP_HOME,
    payload: exp
  })
}

export const setHomepageError = (err) => dispatch => {
  dispatch({
    type: HOMEPAGE_ERROR, 
    payload: {err: err, exp: [] } 
  })
}

export const openNewExp = (a) => dispatch => {
  dispatch({
    type: OPEN_NEW_EXP,
    payload: a
  })
};